import { call, put } from "redux-saga/effects";
import { fetchGeoLocDone, fetchGeoLocError } from "../../state/client/actions";
import { setItemOnLS } from "../../utils/util";

function* fetchGeoLocation({ position }) {
  try {
    // eslint-disable-next-line no-undef
    const latlng = new google.maps.LatLng(
      position.coords.latitude,
      position.coords.longitude
    );
    // eslint-disable-next-line no-undef
    const geocoder = new google.maps.Geocoder();
    const result = yield call(geocoder.geocode, {
      location: latlng
    });

    let location;
    if (result?.results?.length) {
      // Get country
      const country = result.results[0].address_components.find((c) =>
        c.types.includes("country")
      );

      // Get state/province
      const stateProv = result.results[0].address_components.find((c) =>
        c.types.includes("administrative_area_level_1")
      );

      location = {
        countryLong: country.long_name,
        countryShort: country.short_name,
        stateProvLong: stateProv.long_name,
        stateProvShort: stateProv.short_name,
        expiryDate: new Date(new Date().setDate(new Date().getDate() + 1))
      };
      setItemOnLS("presto_geolocation", JSON.stringify(location));
    }
    yield put(fetchGeoLocDone(location));
  } catch (e) {
    yield put(fetchGeoLocError(e));
  }
}

export default fetchGeoLocation;
